import { Seo } from "../components/layout/Seo";
import { ScreeningWizard } from "../components/forms/ScreeningWizard";

export function MoldovaScreening() {
  return (
    <>
      <Seo title="Project Screening" description="Submit a short project screening for an energy, climate, modernization or resilience challenge in Moldova." />

      <section className="bg-bg-primary pt-[calc(var(--header-height)+40px)] pb-[clamp(36px,5vw,56px)]">
        <div className="container-grid max-w-[1000px]">
          <p className="eyebrow mb-4">PROJECT SCREENING</p>
          <h1 className="text-balance text-[clamp(2rem,4.5vw,3.2rem)] font-extrabold leading-[1.05]">Tell us what is happening on the ground.</h1>
          <p className="mt-6 max-w-[760px] text-lg leading-8 text-ink-secondary">You do not need perfect technical knowledge. Approximate figures and a clear description of the problem are enough to begin.</p>
          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold text-ink-secondary">
            {["≈ 4–6 minutes", "Approximate data is fine", "Draft stays on your device until submission"].map((item) => (
              <li key={item} className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-brand-cyan" aria-hidden="true" />{item}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="bg-bg-primary pb-[clamp(64px,8vw,112px)]">
        <div className="container-grid max-w-[1000px]">
          <ScreeningWizard />
        </div>
      </section>
    </>
  );
}
